module.exports = __webpack_public_path__ + "img/bwb8.svg";